import { redirect } from "react-router-dom";
import store from "../../../store/store";
import { brandsSchema } from "../../../types/brands";

export default function motorcycleBrandsLoader() {
  const installationState = store.getState().installation;

  if (installationState.tag === "UNLOADED") return redirect("/");
  if (installationState.tag === "ERROR") return redirect("/error");

  return brandsSchema.parse(
    Array.from(
      new Set(
        installationState.installations
          .filter((i) => i.vehicle === "motorcycle")
          .map((i) => i.brand)
          .sort()
      )
    )
  );
}
